export const ORB_COLOURS = [
  ["#2792DC", "#9CE6E6"],
  ["#6DB035", "#F5CABB"],
  ["#CBA252", "#FFE769"],
  ["#9e93e6", "#e3b6f7"],
  ["#92cb7b", "#e2e98d"],
];
